import { Component, OnInit, ViewChild } from '@angular/core';
import { ImageCropperComponent, ImageCroppedEvent } from 'ngx-image-cropper';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-image-cropper',
  templateUrl: './image-cropper.component.html',
  styleUrls: ['./image-cropper.component.scss'],
})
export class ImgCropperComponent implements OnInit {
  croppedImage: string = null;
  imageToCrop: string;
  @ViewChild(ImageCropperComponent, { static: false })
  imgCropper: ImageCropperComponent;

  constructor(private modalCtrl: ModalController) {}

  ngOnInit() {}

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
  }

  async save() {
    this.imgCropper.crop();
    await this.modalCtrl.dismiss(this.croppedImage);
  }

  async cancel() {
    await this.modalCtrl.dismiss();
  }
}
